import styled from 'styled-components';
import { AllieText } from '../../../../../components';
import { IconContainer } from '../../../LineStatusChip/LineStatusChip.styles';

export const ChainIconContainer = styled(IconContainer)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  width: 28px;
  border-radius: var(--allie-radius-full);
  background: var(--allie-color-neutral-10);
  margin: var(--allie-spacing-md);
`;

export const StyledSuspendedLineContainer = styled.div<{ isCard: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: ${({ isCard }) => (isCard ? 'space-around' : '')};
  height: 100%;
`;

export const StyledTitleText = styled(AllieText)`
  margin-bottom: var(--allie-spacing-xs);
`;
